<template>
  <div class="nine-page flex-column justify-between align-center">
    <!-- <page-white-background title="初中中级体验词库" router-type="modal"> -->
    <ion-header class="ion-no-border">
      <div class="navbar flex-row align-center justify-between">
        <div style="display: inline-flex; align-items: center">
          <!--          <switch-font-size />-->
          <img
            class="nav-icon cursor-pointer"
            :src="getBrandImageUrl('ai_smart_reading/nav_back.png')"
            alt=""
            @click="onClose"
          />
        </div>
        <div class="course-name flex-row align-center" @click="showCourseSelect()">
          <div v-if="courseName" class="course-name_text text-overflow-ellipsis">
            {{ courseName }}
          </div>
          <div v-else>请选择要体验的词库</div>
          <img
            class="bottom-icon"
            :src="getBrandImageUrl('ai_smart_reading/nav_back.png')"
            alt=""
          />
        </div>
      </div>
    </ion-header>
    <div class="flex-column align-center">
      <div class="nine-square">
        <img class="nine-square_bg" src="@/assets/student/version5/nine_circle_bg.png" alt="" />
        <!--        <img-->
        <!--          class="circle-center"-->
        <!--          src="@/assets/teacher_index/version5/nine_circle_center.svg"-->
        <!--          alt=""-->
        <!--          @click="openBeforeTest"-->
        <!--        />-->
        <div class="circle-center" @click="openBeforeTest"></div>
        <div class="circle-text text0" :class="{ 'shrink-font': step0 > 999 }">
          {{ step0 || 0 }}
        </div>
        <div
          class="circle-text text1"
          :class="{ 'shrink-font': step1 > 999 }"
          @click="onMastery(step1, 1)"
        >
          {{ step1 }}
        </div>
        <div
          class="circle-text text2"
          :class="{ 'shrink-font': step2 > 999 }"
          @click="onMastery(step2, 2)"
        >
          {{ step2 }}
        </div>
        <div
          class="circle-text text3"
          :class="{ 'shrink-font': step3 > 999 }"
          @click="onMastery(step3, 3)"
        >
          {{ step3 }}
        </div>
        <div
          class="circle-text text4"
          :class="{ 'shrink-font': step4 > 999 }"
          @click="onMastery(step4, 4)"
        >
          {{ step4 }}
        </div>
        <div
          class="circle-text text5"
          :class="{ 'shrink-font': step5 > 999 }"
          @click="onMastery(step5, 5)"
        >
          {{ step5 }}
        </div>
        <div
          class="circle-text text6"
          :class="{ 'shrink-font': step6 > 999 }"
          @click="onMastery(step6, 6)"
        >
          {{ step6 }}
        </div>
        <div
          class="circle-text text7"
          :class="{ 'shrink-font': step7 > 999 }"
          @click="onMastery(step7, 7)"
        >
          {{ step7 }}
        </div>
        <div
          class="circle-text text8"
          :class="{ 'shrink-font': step8 > 999 }"
          @click="onMastery(step8, 8)"
        >
          {{ step8 }}
        </div>
      </div>
      <div class="nine-tips">
        <div class="nine-tips_top">拉通式复习单词训练</div>
        <div class="nine-tips_bottom">每复习一次，单词向前走一格</div>
      </div>
      <div class="drawers">
        <div class="drawers-content flex-column justify-between">
          <div class="drawers-content_course flex-row align-center justify-between">
            <img class="book" src="@/assets/teacher_index/version5/sign_book_icon.svg" alt="" />
            <div class="course-info flex-column justify-between">
              <div class="course-info_user flex-row align-center">
                <div class="student-name">{{ studentName }}</div>
                <img class="time-img" :src="statusObj[classTimeType]" alt="" />
              </div>
              <div class="course-name flex-row align-center">
                <div v-if="courseName" class="course-name_text text-overflow-ellipsis">
                  {{ courseName }}
                </div>
                <div v-else class="course-name_empty">未选择词库</div>
              </div>
              <!--              <div class="drawers-content_progress">
                <ion-progress-bar class="bar" :value="progressValue"></ion-progress-bar>
              </div>
              <div class="finished flex-row align-center justify-between">
                <span>已完成 {{ ((totalNum || 0) / 1500).toFixed(2) }}%</span>
                <span>{{ totalNum || 0 }}/1500词</span>
              </div>-->
            </div>
          </div>
          <div v-if="classScope" class="drawers-content_time flex-row align-center">
            <img
              class="drawers-content_book"
              src="@/assets/teacher_index/version5/nine_clock.svg"
              alt=""
            />
            <span>训练时间：{{ classScope }}</span>
          </div>
          <div class="drawers-content_statistic flex-row justify-around align-center">
            <div class="statistic">
              <div class="num">{{ learnNum || 0 }}</div>
              <span class="label">今日识词(个)</span>
            </div>
            <div class="statistic">
              <div class="num">{{ reviewNum || 0 }}</div>
              <span class="label">今日待复习(个)</span>
            </div>
            <div class="statistic">
              <div class="num">{{ totalNum || 0 }}</div>
              <span class="label">累计识词</span>
            </div>
          </div>
        </div>
      </div>
      <div class="buttons flex-row justify-around">
        <ion-button class="buttons-button orange" shape="round" @click="onContinue"
          >继续练习
        </ion-button>
        <ion-button class="buttons-button linear-green" shape="round" @click="clickReviewButton"
          >开始复习
        </ion-button>
      </div>
    </div>
    <div class="bottom-logo">
      <!--      <img src="@/assets/student/version5/bottom_logo.svg" alt="" />-->
    </div>
    <!-- </page-white-background> -->
  </div>
</template>

<script>
import { actionSheetController, IonButton, IonHeader, modalController } from "@ionic/vue"

import BeforeTest from "@/views/speed/BeforeTest"
import Review from "@/views/speed/Review"
import Sign from "@/views/speed/Sign"
import { caretDown, library } from "ionicons/icons"
import { BRAND_IMAGES, getBrandImageUrl } from "@/js/brandImages.ts"
import Time30 from "@/assets/teacher_index/version5/time_30.svg"
import Time60 from "@/assets/teacher_index/version5/time_60.svg"
import TimeExperience from "@/assets/teacher_index/version5/time_exper.svg"

export default {
  name: "SpeedReview",
  components: {
    IonHeader,
    IonButton,
  },
  props: ["studentId", "readingId"],
  setup() {
    return {
      library,
      caretDown,
    }
  },
  data() {
    return {
      courseId: undefined,
      courseName: undefined,
      reviewNum: 0,
      learnNum: 0,
      totalNum: 0,
      currentNum: 0,
      step0: 0,
      step1: 0,
      step2: 0,
      step3: 0,
      step4: 0,
      step5: 0,
      step6: 0,
      step7: 0,
      step8: 0,

      //################################
      buttons: [],
      brandImages: BRAND_IMAGES,
      studentName: "", // 学生姓名
      classTimeType: "", // 练习类型 30分钟 | 60分钟 | 体验课
      classScope: "", // 练习时间的范围
      startTime: "",
      endTime: "",
      progressValue: 0.3,
      statusObj: {
        1: Time30,
        2: Time60,
        3: TimeExperience,
        4: "",
      },
      isTrial: false,
    }
  },

  mounted() {
    this.appointment = this.store.getAppointment()
    this.isTrial = this.appointment.classification === 3
    console.log("aaa", this.appointment.courseName)
    if (this.appointment.courseId) {
      this.learningInfo()
    }
    this.queryMyCourseList()
    this.getAudioPath() //获取音频文件路径
    this.initNineStudentInfo()
  },

  methods: {
    getBrandImageUrl,
    //显示选择资料列表
    async showCourseSelect() {
      const actionSheet = await actionSheetController.create({
        header: "选择资料",
        cssClass: "myActionSheet",
        buttons: this.buttons,
      })
      await actionSheet.present()
    },

    learningInfo() {
      this.ajax.get("/vocabulary/learningInfo?studentId=" + this.studentId).then((res) => {
        this.courseId = res.data.courseId
        this.courseName = res.data.courseName
        this.reviewNum = res.data.reviewNum
        this.learnNum = res.data.learnNum
        this.totalNum = res.data.totalNum
        this.currentNum = res.data.currentNum
        this.step0 = res.data.step0
        this.step1 = res.data.step1
        this.step2 = res.data.step2
        this.step3 = res.data.step3
        this.step4 = res.data.step4
        this.step5 = res.data.step5
        this.step6 = res.data.step6
        this.step7 = res.data.step7
        this.step8 = res.data.step8

        this.appointment.courseName = this.courseName
        this.appointment.courseId = this.courseId
        this.store.setAppointment(this.appointment)
      })
    },

    //学新
    async openBeforeTest() {
      if (!this.courseName && this.isTrial) {
        this.alert("请选择要体验的词库")
        return
      }
      this.ajax
        .get(
          "/vocabulary/countNotInPersonal?studentId=" +
            this.studentId +
            "&courseId=" +
            this.courseId
        )
        .then(async (res) => {
          if (res.data.success) {
            if (res.data.count > 0) {
              sessionStorage.setItem("isNew", "0")
              const modal = await modalController.create({
                component: BeforeTest,
                componentProps: { studentId: this.studentId },
                cssClass: "modal_controller_class",
              })
              await modal.present()
              const { data } = await modal.onDidDismiss()
              console.log("nine1", data)
              if (data) {
                if (data.status === "TO_ARTICLE" || data.status === "TO_ARTICLE") {
                  await modalController.dismiss({ ...data })
                } else {
                  this.learningInfo()
                }
              }
            } else {
              this.alert("本词库已训完，请复习或选其他资料库训练！")
            }
          }
        })
    },

    //复习
    async openReview(mastery) {
      sessionStorage.setItem("isNew", "1")
      const modal = await modalController.create({
        component: Review,
        componentProps: { studentId: this.studentId, mastery: mastery },
        cssClass: "modal_controller_class",
      })
      await modal.present()
      const { data } = await modal.onDidDismiss()
      console.log("review", data)
      if (data) {
        if (data.status === "TO_ARTICLE") {
          await modalController.dismiss({ ...data })
        } else {
          this.learningInfo()
        }
      } else {
        this.learningInfo()
      }
    },

    async openSign() {
      const modal = await modalController.create({
        component: Sign,
        componentProps: { studentId: this.studentId },
        cssClass: "modal_controller_class",
      })

      await modal.present()
      const { data } = await modal.onDidDismiss()
      if (data) {
        if (data.status === "TO_ARTICLE") {
          await modalController.dismiss({ ...data })
        }
      }
    },

    clickReviewButton() {
      if (!this.courseName && this.isTrial) {
        this.alert("请选择要体验的词库")
        return
      }
      this.openReview(0)
    },

    //继续练习
    onContinue() {
      if (!this.courseName && this.isTrial) {
        this.alert("请选择要体验的词库")
        return
      }
      if (this.currentNum > 0) {
        this.openSign()
      } else {
        this.openBeforeTest()
      }
    },

    onMastery(num, mastery) {
      if (!this.courseName && this.isTrial) {
        this.alert("请选择要体验的词库")
        return
      }
      if (num && num > 0) {
        this.openReview(mastery)
      }
    },

    doRefresh(RefreshAnimationEvent) {
      this.tools.closeRefreshAnimation(RefreshAnimationEvent, 200)
      this.dataList = []
      this.learningInfo()
      this.queryMyCourseList()
    },

    //
    queryMyCourseList() {
      const that = this
      const studentId = this.store.getStudentId()
      const appointment = this.store.getAppointment()
      let trial = true

      if (appointment != null) {
        trial = appointment.classification == 3
      }

      this.ajax
        .get("/course/queryMyCourseList?studentId=" + studentId + "&trial=" + trial)
        .then((res) => {
          if (res.data.success) {
            if (res.data.list) {
              that.buttons = []
              res.data.list.forEach((item) => {
                let strTitle = ""
                if (item.finished) {
                  strTitle = item.courseName + "   (已训完)"
                }

                //显示学新数量
                else {
                  if (item.learnNewNumber) {
                    strTitle = item.courseName + "  " + item.learnNewNumber + "/" + item.number
                  } else {
                    strTitle = item.courseName
                  }
                }

                const param = {
                  studentId: studentId,
                  courseId: item.courseId,
                  aptmId: appointment.aptmId,
                  schoolId: appointment.schoolId,
                  courseName: item.courseName,
                }

                let showButton = false

                //体验课
                if (appointment.classification == 3) {
                  showButton = true
                }

                //其它资料类型
                //如果是阅读课，则限制词库范围
                else if (
                  (appointment.courseTypeId == 3 && item.courseTypeId == 3) ||
                  (appointment.courseTypeId == 1 && item.courseTypeId == 1)
                ) {
                  showButton = true
                }

                if (showButton) {
                  that.buttons.push({
                    text: strTitle,
                    handler: () => {
                      that.ajax.post("/course/changeCourse", param).then((res1) => {
                        if (res1.data.success) {
                          that.courseName = item.courseName
                          that.learningInfo()
                        }
                      })
                    },
                  })
                }
              })
            }

            that.buttons.push({ text: "取消", role: "cancel" })
          }
        })
    },

    //获取音频文件路径
    getAudioPath() {
      this.ajax.get("/config/getConfig?key=AUDIO_INNER_PATH").then((res) => {
        if (res.data.success) {
          this.setAudioInnerPath(res.data.data)
        }
      })
    },

    initNineStudentInfo() {
      // 资料类型 3 体验课 2 60分钟 1 30分钟
      let studentInfo = this.store.getAppointment()
      if (studentInfo.aptmId == 0) {
        studentInfo = this.store.getUser()
      }
      this.studentName = studentInfo.studentName || studentInfo.username
      this.classTimeType = studentInfo.classification || ""
      if (studentInfo.startTime && studentInfo.endTime) {
        this.classScope = studentInfo.startTime + "-" + studentInfo.endTime
      } else {
        this.classScope = null
      }
      this.startTime = studentInfo.startTime
      this.endTime = studentInfo.endTime
    },
  },
}
</script>

<style scoped lang="less">
@import "@/assets/common.less";

.nine-page {
  width: 100%;
  height: 100%;
  overflow: auto;
  background: linear-gradient(180deg, #dcf8ef 0%, #f2f3f7 60%);

  .navbar {
    width: 100%;
    height: 5rem;
    text-align: center;
    position: relative;
    font-size: 1rem;
    font-weight: 600;
    padding: 0 0.2rem;

    .course-name {
      background: #ffffff;
      padding: 0.5rem 1rem;
      width: 90%;
      border-radius: 0.5rem;
      color: #1e2023;
      font-size: 1rem;
      position: relative;
      cursor: pointer;
    }

    .bottom-icon {
      position: absolute;
      width: 1.2rem;
      right: 0.5rem;
      top: 50%;
      transform: translateY(-50%) rotate(-90deg);
    }

    .nav-icon {
      width: 2rem;
    }
  }

  .nine-square {
    width: 21rem;
    height: 21rem;
    position: relative;

    &_bg {
      width: 100%;
      position: relative;
      z-index: 1;
    }

    .nine-circle1 {
      position: absolute;
      left: 16%;
      top: 64%;
      width: 5.1rem;
      z-index: 2;
    }

    .nine-circle2 {
      position: absolute;
      left: 8%;
      top: 46%;
      width: 4.7rem;
      z-index: 2;
    }

    .nine-circle3 {
      position: absolute;
      left: 10%;
      top: 20%;
      width: 5.1rem;
      z-index: 2;
    }

    .nine-circle4 {
      position: absolute;
      left: 26%;
      top: 8%;
      width: 5.3rem;
      z-index: 2;
    }

    .nine-circle5 {
      position: absolute;
      left: 54%;
      top: 9%;
      width: 4.8rem;
      z-index: 2;
    }

    .nine-circle6 {
      position: absolute;
      left: 66%;
      top: 21%;
      width: 5.4rem;
      z-index: 2;
    }

    .nine-circle7 {
      position: absolute;
      left: 70%;
      top: 46%;
      width: 4.6rem;
      z-index: 2;
    }

    .nine-circle8 {
      position: absolute;
      left: 60%;
      top: 63%;
      width: 5.2rem;
      z-index: 2;
    }

    .circle-center {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 7rem;
      height: 7rem;
      z-index: 2;
    }

    .circle-text {
      color: #ffffff;
      width: 2.4rem;
      height: 2.4rem;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 600;
    }

    .shrink-font {
      font-size: 0.8rem;
    }

    .text0 {
      position: absolute;
      left: 45%;
      top: 73.2%;
      z-index: 3;
      color: #cbcbcb;
    }

    .text1 {
      position: absolute;
      left: 26.7%;
      top: 66.7%;
      z-index: 3;
      color: #e95525;
    }

    .text2 {
      position: absolute;
      left: 16.5%;
      top: 50%;
      z-index: 3;
      color: #f4c531;
    }

    .text3 {
      position: absolute;
      left: 18.5%;
      top: 30%;
      z-index: 3;
      color: #a2deb5;
    }

    .text4 {
      position: absolute;
      left: 34.3%;
      top: 16.5%;
      z-index: 3;
      color: #7ed5a8;
    }

    .text5 {
      position: absolute;
      left: 53.5%;
      top: 16.5%;
      z-index: 3;
      color: #41bd7a;
    }

    .text6 {
      position: absolute;
      left: 69.5%;
      top: 28.7%;
      z-index: 3;
      color: #41bd7a;
    }

    .text7 {
      position: absolute;
      left: 73%;
      top: 47.6%;
      z-index: 3;
      color: #1b9766;
    }

    .text8 {
      position: absolute;
      left: 64%;
      top: 65.7%;
      z-index: 3;
      color: #125543;
    }
  }

  .drawers {
    width: 25rem;
    margin: 1rem 0;
    display: flex;
    border-radius: 0.8rem;
    background: #ffffff;
    padding: 2rem 1rem;

    &-content {
      flex: 1;
      width: 100%;
      height: 100%;
      z-index: 2;

      &_progress {
        width: 100%;
      }

      &_course {
        padding: 0 1rem;

        .book {
          width: 2.8rem;
          margin-right: 1rem;
        }

        .course-info {
          flex: 1;
          width: 100%;
          height: 90%;

          &_user {
            font-size: 1.1rem;
            font-weight: 600;

            .student-name {
              width: 62%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            img {
              height: 1.4rem;
              margin-left: 0.5rem;
            }
          }

          .course-name {
            color: #1e2023;
            font-size: 1.1rem;
            font-weight: 600;

            &_text {
              max-width: 18rem;
              font-weight: 400;
              color: #3f4140;
              font-size: 0.8rem;
            }

            .course-name_empty {
              color: #9a9b9c;
              font-size: 0.8rem;
              font-weight: normal;
            }

            .triangle {
              width: 0.5rem;
              margin-left: 0.5rem;

              &::after {
                content: "";
                display: inline-block;
                width: 0;
                height: 0;
                border-top: 0.2rem solid transparent;
                border-bottom: 0.2rem solid #1e2023;
                border-right: 0.2rem solid #1e2023;
                border-left: 0.2rem solid transparent;
              }
            }
          }

          .course-top {
            background: #ffffff;
          }
        }

        .finished {
          color: #676767;
          font-size: 0.8rem;
        }
      }

      //&_progress {
      //  margin: 0.5rem 0;
      //  .bar {
      //    border-radius: 0.5rem;
      //    &::part(progress) {
      //      background: #2bca9c;
      //    }
      //    &::part(track) {
      //      background: #e9e7e7;
      //    }
      //  }
      //}
      &_time {
        color: #676767;
        font-size: 0.9rem;
        margin-top: 1rem;
        padding: 0 1rem;

        img {
          width: 1rem;
          margin-right: 0.3rem;
        }
      }

      &_statistic {
        text-align: center;
        margin-top: 1rem;

        .statistic {
          background: #fafafa;
          border-radius: 0.6rem;
          padding: 0.8rem 0;
          flex: 1;

          &:nth-child(2) {
            margin: 0 0.4rem;
          }
        }

        .num {
          color: #1e2023;
          font-weight: 500;
          font-size: 1.2rem;
        }

        .label {
          color: #9a9b9c;
          font-size: 0.85rem;
        }
      }
    }
  }

  .buttons {
    width: 25rem;

    &-button {
      width: 45%;
      height: 3rem;
      font-size: 1rem;
      --box-shadow: none;
    }

    .orange {
      --background: transparent;
      --border-color: #004227;
      --border-width: 0.09rem;
      --border-style: solid;
      color: #004227;
    }

    .linear-green {
      --background: #004227;
      color: #ffffff;
    }
  }

  .bottom-logo {
    width: 70%;
    height: 3rem;

    img {
      width: 100%;
    }
  }

  &_page {
    width: 100%;
    height: 100%;
  }

  &_card {
    box-shadow: 0 0 1px 0 var(--mark-border-color);
    padding: 4vw 3vw;

    .user-name {
      font-size: var(--font-3);
    }

    .class-type {
      height: 3.5vw;
    }

    .nine-avatar {
      width: 10vw;
      object-fit: contain;
    }

    .nine-info {
      width: 100%;
    }

    .text {
      color: var(--font-black-color);
    }

    .class-time {
      color: var(--font-deep-gray);
      padding-bottom: 3vw;
      margin-bottom: 3vw;

      img {
        margin-bottom: 0.3vh;
      }
    }

    .class-statistic {
      border-top: 1px solid var(--border-color-1);
      padding-top: 3vw;

      & > div {
        text-align: center;
        color: var(--font-deep-gray);
      }

      .num {
        font-size: var(--font-5);
        font-weight: 600;
        line-height: 2.5rem;
        color: var(--font-black-color);
      }
    }
  }

  .dashboard {
    position: relative;
    width: 90%;
    margin: 0 auto;

    &_image {
      position: relative;
      width: 100%;
      z-index: 4;
    }

    &_content {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 50%;
    }

    &_button {
      position: absolute;
      left: 50%;
      bottom: 60%;
      width: 20%;
      z-index: 5;
      transform: translate(-50%, -50%);
    }

    &_block {
      width: 100%;
      height: 100%;

      .white-block {
        position: absolute;
        left: 0;
        bottom: 7%;
        width: 100%;
        z-index: 5;
      }

      .pointer {
        position: absolute;
        left: 0;
        top: -98%;
        width: 100%;
        transform: rotate(24deg);
        z-index: 3;
      }

      .line {
        position: absolute;
        left: 0;
        bottom: 73%;
        width: 100%;
        z-index: 6;
      }

      .block-left {
        position: absolute;
        left: 2%;
        bottom: 85%;
        width: 20%;
        z-index: 4;
      }

      .block-right {
        position: absolute;
        right: 2%;
        bottom: 85%;
        width: 20%;
        z-index: 4;
      }

      .button {
        position: absolute;
        left: 12%;
        bottom: 48%;
        width: 50%;
        z-index: 7;
        white-space: nowrap;
        //font-weight: 600;

        img {
          width: 20%;
          margin-left: 5%;
        }
      }

      .continue-button {
        left: 12%;
      }

      .start-button {
        left: 69%;
      }
    }
  }
}

.nine-tips {
  margin-top: 1rem;
  text-align: center;

  &_top {
    color: #125543;
    font-size: 1.2rem;
    margin-bottom: 0.2rem;
  }

  &_bottom {
    color: #999999;
    font-size: 0.9rem;
  }
}
</style>
